// extracted by mini-css-extract-plugin
module.exports = {"notificator":"Notificator_notificator__2kNNI"};